/* @ngInject */
function SidebarMenuGuestController ($rootScope, $scope, $timeout, $translate, $sce, UserService, CustomerConfigurationsService) {
  $scope.showDropdown = false
  $scope.expanded = false
  $scope.user = {}
  $scope.avatarUrl = ''
  $scope.tooltipText = ''
  $scope.showAvatarDropdown = false

  var sidebarAnimationTimeout = null

  const api = {
    _expandSidebar,
    _collapseSidebar,
    _handleSidebarColor,
    _getInitialData,
    _getUserImage
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getInitialData()

    $timeout(() => {
      const sidebarElement = $('sidebar-menu-guest .sidebar-menu-guest')
      sidebarElement.on('mouseenter', api._expandSidebar)
      sidebarElement.on('mouseleave', api._collapseSidebar)
      api._handleSidebarColor(sidebarElement[0])
    }, 0, true)
  }

  function _getUserImage () {
    return UserService.getUserProfileImage($scope.user.id)
  }

  function _expandSidebar () {
    sidebarAnimationTimeout = $timeout(() => {
      if (!$scope.showAvatarDropdown) {
        $scope.expanded = true
      }
    }, 200, true)
  }

  function _collapseSidebar () {
    $timeout.cancel(sidebarAnimationTimeout)
    $timeout(() => {
      $scope.expanded = false
      $scope.showDropdown = false
      $scope.showAvatarDropdown = false
    }, 0, true)
  }

  function _getInitialData () {
    Promise.all([
      $rootScope.getUserCompany(),
      $rootScope.getCompanyFeaturesAndAddons(),
      $rootScope.getUser()
    ]).then(([userCompany, companyFeatures, user]) => {
      $scope.features = companyFeatures.features
      $scope.user = user
      $scope.companyName = userCompany.formattedName

      const translatedText = $translate.instant('guest.sidebarDropdown.title', {
        companyName: userCompany.formattedName,
        guestEmail: user.email
      })
      $scope.sanitizedDropdownText = $sce.trustAsHtml(translatedText)

      $scope.avatarUrl = api._getUserImage()
    })
  }

  function _handleSidebarColor (sidebarElement) {
    CustomerConfigurationsService.getOneConfigurationByType('COMPANY_PRIMARY_COLOR', 'STRING')
      .then(({ value }) => {
        const color = value || $rootScope.customerColor || '#00abc8'
        const activeColor = color + '33'
        const hoverColor = color + '14'

        sidebarElement.style.setProperty('--mySidebarColorActive', activeColor)
        sidebarElement.style.setProperty('--mySidebarColorHover', hoverColor)
      })
  }

  $scope.openAvatarDropdown = (e) => {
    $scope.showAvatarDropdown = !$scope.showAvatarDropdown
  }

  $scope.closeAvatarDropdown = () => {
    $scope.showAvatarDropdown = false
  }

  $scope.closeSidebarMenuGuest = function () {
    if ($rootScope.fnLogOutUser) {
      $rootScope.fnLogOutUser({ logoutByClick: true })
    }
  }

  $scope.toggleSidebar = () => {
    $('.sidebar-menu-guest').transition('slide right')
  }
}

export { SidebarMenuGuestController }
